import React from "react";
import coreValuesImg from "../../../assets/coreValues.svg";
import InfoSection from "../../common/InfoSection";
import FeaturesGrid from "../../common/FeatureGrid";
import { coreValues } from "../../../constants/data";

function CoreValues() {
  return (
    <div 
      id="core-values"
      className="max-w-1200 mx-auto w-full"
    >
      <div className="px-4 sm:px-6 lg:px-0">
        <div className="flex flex-col gap-20">
          <InfoSection
            subtitle="Our Core Values"
            description="Our global mission is to empower every business to manage all aspects of compliance—automating, monitoring, and optimizing—effortlessly and efficiently."
            width="lg:max-w-2xl max-w-xl px-3"
            descriptionHidden={false}
          />
          <FeaturesGrid imageUrl={coreValuesImg} features={coreValues} />
        </div>
      </div>
    </div>
  );
}

export default CoreValues;
